import React, { useEffect, useState } from 'react';
import { enablePushNotifications, getPushStatus, sendTestPushNotification } from '../pushNotifications';

function PushNotificationControl() {
  const [status, setStatus] = useState({ supported: false, permission: 'default', subscribed: false });
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let mounted = true;
    getPushStatus().then((next) => {
      if (mounted) setStatus(next);
    });
    return () => { mounted = false; };
  }, []);

  if (hidden || !status.supported || status.subscribed) {
    return null;
  }

  const enable = async () => {
    try {
      setBusy(true);
      setMessage('');
      await enablePushNotifications();
      const next = await getPushStatus();
      setStatus(next);
      setMessage('تم تفعيل إشعارات الهاتف لهذا الجهاز');
      setTimeout(() => setHidden(true), 2500);
    } catch (error) {
      setMessage(error.message || 'تعذر تفعيل الإشعارات');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="push-control-card" dir="rtl">
      <div className="push-control-icon">🔔</div>
      <div className="push-control-body">
        <strong>فعّل إشعارات الهاتف</strong>
        <span>ستصلك تنبيهات عند أي عملية جديدة أو إشعار عام داخل النظام.</span>
        {message && <small>{message}</small>}
      </div>
      <div className="push-control-actions">
        <button type="button" onClick={enable} disabled={busy}>
          {busy ? 'جاري التفعيل...' : 'تفعيل'}
        </button>
        <button type="button" className="push-control-secondary" onClick={() => setHidden(true)}>
          لاحقاً
        </button>
      </div>
    </div>
  );
}

export function PushTestButton() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  const test = async () => {
    try {
      setBusy(true);
      setMessage('');
      await sendTestPushNotification();
      setMessage('تم إرسال إشعار اختبار');
    } catch (error) {
      setMessage(error.message || 'فشل الاختبار');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="push-test-inline">
      <button type="button" onClick={test} disabled={busy}>
        {busy ? 'جاري الإرسال...' : 'اختبار إشعارات الهاتف'}
      </button>
      {message && <span>{message}</span>}
    </div>
  );
}

export default PushNotificationControl;
